import DCModuleDetailsPage from '../DCModuleDetailsPage/DCModuleDetailsPage';

const MCModuleDetailsPage = DCModuleDetailsPage;

export default MCModuleDetailsPage;
